// React basic
import { useEffect, useState } from 'react'
import { useNavigate, Link, useSearchParams } from "react-router-dom"


// Tailwind
import {
  ChatBubbleLeftRightIcon,
  IdentificationIcon,
  PlayCircleIcon,
  ChartPieIcon,
} from '@heroicons/react/20/solid'
import { ChevronRightIcon, ChevronDownIcon } from '@heroicons/react/16/solid'

// // Components - utility
// import Background from '../components/Background'
// import Container from '../components/Container'
// import Button from '../components/Button'

// // Components - sections
// import BestInClass from '../components/BestInClass'
// import Investors from '../components/Investors'
// import Pilot from '../components/Pilot'
// import ValuePropositions from '../components/ValuePropositions'
// import PerformanceSecuritySafety from '../components/PerformanceSecuritySafety'


// import { LogoTextOnly } from '../components/logo'



// // Other libraries
// import ReactLoading from 'react-loading'
// import axios from 'axios'


// // Custom
// import { mixpanel_client_track } from "../libs/mixpanelClient"


const IndexPage = ({

  
} : {

  
}) => {


  // Navigate
  const navigate = useNavigate()

  // Search params
  // const [search_params, _] = useSearchParams()

  // const param_journey = search_params.get("journey")

  // States  
  // const [demo_is_active, set_demo_is_active] = useState(false);
  // const [demo_is_active, set_demo_is_active] = useState(demo_is_active_options[0]);
  // const [demo_is_active, set_demo_is_active] = useState(param_demo_is_active === "true")
  // const [hero_dropdown_is_open, set_hero_dropdown_is_open] = useState(false);

  // Modal
  // const [demo_modal_is_open, set_demo_modal_is_open] = useState(false)
  
  
  
  useEffect(() => {

    // // Mixpanel tracking
    // mixpanel_client_track("www_index_visited", null)
    
  }, [])

  return (
    <div id="top" className="">
      
      Channy Hong

    </div>
  )
}



export default IndexPage